<ng-container *transloco="let tloco; prefix: 'subscriptions.my-subscription'">
  <div class="h-full rounded-md border border-steel-20">
    <div class="flex flex-col gap-y-6 p-3 md:p-6">
      <div class="flex gap-x-2">
        <rma-icon glyph="social-google-colour" />
        <div>
          <div class="text-button md:mb-4">{{ tloco('insights-google-profile') }}</div>
          @if (profileOwnerName) {
            <div class="text-steel-80 md:-mb-2 md:-mt-4">
              {{ tloco('insights-google-profile-owner', { profileOwnerName }) }}
            </div>
          }
        </div>
      </div>
      <div class="flex">
        <rma-stat-block
          class="flex w-1/2 flex-col"
          [blurb]="tloco('insights-reviews', { count: $safeNavigationMigration(insights?.convertedFromRmaReviewsCount) })"
          [value]="insights?.convertedFromRmaReviewsCount ?? 0"
        />
        @if (isComparison) {
          @if (comparisonValue) {
            <rma-comparison-stat class="flex w-1/2 flex-col" [label]="tloco('insights-google-rating')" [comparisonStat]="comparisonValue" />
          }
        } @else {
          <rma-stat-block class="flex w-1/2 flex-col" [blurb]="tloco('insights-google-rating')" [value]="singleValue" />
        }
      </div>
      <p class="italic">{{ tloco('insights-google-info', { count: $safeNavigationMigration(insights?.convertedFromRmaReviewsCount) }) }}</p>
    </div>
  </div>
</ng-container>
